import React from "react";
import {FaEraser} from "react-icons/fa";
import InputForm from "../../../../components/input/input-form.jsx";

const DashboardSearch = ({value, onChange, onClear, labelId, className = ""}) => (
    <div className={["flex items-center gap-1 px-1.5 py-1", className].join(" ")}>
        <InputForm
            classNameWrapper={"w-full"}
            id={labelId}
            name={"search"}
            label="Pesquisar"
            value={value}
            onChange={({target}) => onChange(target.value)}
        />
        <button
            type="button"
            title="Limpar"
            onClick={onClear}
            className="flex h-8 w-8 items-center justify-center rounded-sm border border-[#bdbdbd] bg-white text-[#918b8b] hover:bg-gray-100 cursor-pointer"
        >
            <FaEraser size={12}/>
        </button>
    </div>
);

export default DashboardSearch;
